import "../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../identidad/Pide 1.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Modal, Button, Form } from "react-bootstrap";

const Login = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [usuario, setUsuario] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [datos, setDatos] = useState();
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [codigo, setCodigo] = useState("");
  const [nuevaContrasenia, setNuevaContrasenia] = useState("");
  const [confirmarContrasenia, setConfirmarContrasenia] = useState("");
  const [modalPaso, setModalPaso] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("apiKey") && localStorage.getItem("apiKey") !== undefined) {
      const rol = localStorage.getItem("rol");
      if (rol === "comunicacion") navigate("/DashboardComunicacion");
      else if (rol === "finanzas") navigate("/DashboardFinanzas");
      else if (rol === "soporte") navigate("/DashboardSoporte");
      else if (rol === "coordinador") navigate("/DashboardCoordinador");
      else localStorage.clear();
    }
  }, [navigate]);

  const redirigirYguardarSesion = (datos) => {
    localStorage.setItem("apiKey", datos.tokenJWT);
    localStorage.setItem("rol", datos.rol);
    localStorage.setItem("email", datos.email);
    localStorage.setItem("nombre", datos.nombre);
    localStorage.setItem("userId", datos.userId);
    console.log(datos);
    switch (datos.rol) {
      case "comunicacion": navigate("/DashboardComunicacion"); break;
      case "soporte": navigate("/DashboardSoporte"); break;
      case "coordinador": navigate("/DashboardCoordinador"); break;
      case "auditoria": navigate("/DashboardAuditoria"); break;
      default: navigate("/DashboardFinanzas");
    }
  };

  const actualizarUsuario = (e) => setUsuario(e.target.value);
  const actualizarContrasenia = (e) => setContrasenia(e.target.value);

  const iniciarSesion = async () => {
    const login = {
      email: usuario, password: contrasenia, id: 0,
      nombre: "", rol: "", telefono: "", apellido: "", cedulaIdentidad: "",
    };
    try {
      let respuesta = await fetch(`${apiUrl}/Usuarios/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(login),
      });
      const datos = await respuesta.json();
      console.log(datos);
      if (respuesta.status === 200) {
        setDatos(datos);
        redirigirYguardarSesion(datos);
      } else {
        manejarErrores(respuesta.status);
      }
    } catch (error) {
      console.error("Error inesperado", error);
      toast.error("Error inesperado", { position: "bottom-center" });
    }
  };

  const manejarErrores = (estatus) => {
    let error = "";
    switch (estatus) {
      case 400: error = "Solicitud incorrecta. Verifica los datos enviados."; break;
      case 401: error = "Usuario o contraseña incorrectos."; navigate("/"); break;
      case 403: error = "Acceso denegado."; navigate("/dashboardCoordinador"); break;
      case 500: error = "Error interno del servidor. Inténtalo de nuevo más tarde."; break;
      default: error = "Ocurrió un error inesperado."; break;
    }
    if (error) toast.error(error, { position: "bottom-center", autoClose: 3000, theme: "light" });
  };

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => { setModalPaso(1); setShowModal(true); };

  const toastOpts = {
    position: "bottom-center", autoClose: 3000,
    hideProgressBar: false, closeOnClick: true,
    pauseOnHover: true, draggable: true, theme: "light",
  };

  const SolicitarCodigo = async () => {
    if (!email) { toast.warn("Por favor, ingresa tu correo electrónico.", toastOpts); return; }
    try {
      let respuesta = await fetch(`${apiUrl}/Usuarios/CodigoDeRecuperacion`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ codigo: 0, email, contrasenia: "" }),
      });
      if (!respuesta.ok) { toast.error("Error, verifique correo electrónico", toastOpts); return; }
      toast.success("Código enviado al correo electrónico.", toastOpts);
      setModalPaso(2);
    } catch (error) {
      console.error(error);
      toast.error("Error durante la solicitud de código.", toastOpts);
    }
  };

  const CambiarContraseña = async () => {
    if (nuevaContrasenia !== confirmarContrasenia) {
      toast.warn("Las contraseñas no coinciden.", toastOpts);
      return;
    }
    try {
      let respuesta = await fetch(`${apiUrl}/Usuarios/CambiarContreasenia`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ codigo, email, contrasenia: nuevaContrasenia }),
      });
      if (!respuesta.ok) { toast.error("Error al restablecer la contraseña, verifique código", toastOpts); return; }
      toast.success("Contraseña restablecida con éxito.", toastOpts);
      handleCloseModal();
    } catch (error) {
      console.error(error);
      toast.error("Error durante el restablecimiento de la contraseña.", toastOpts);
    }
  };

  // Estilos reutilizables
  const inputStyle = {
    borderRadius: "10px",
    border: "1px solid #e0e0e0",
    background: "#ffffffff",
    fontSize: "1rem",
  };

  const btnPrincipalStyle = {
    borderRadius: "10px",
    background: "var(--color-principal, #008B9C)",
    color: "#fff",
    fontWeight: 500,
    border: "none",
    padding: "12px",
    fontSize: "1rem",
    cursor: "pointer",
    width: "100%",
  };

  const labelStyle = {
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: "#888",
    marginBottom: "6px",
  };

  return (
    <div className="container d-flex flex-column" style={{ minHeight: "100vh" }}>
      <div className="row vh-100">
        <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
          <div className="d-table-cell align-middle">

            {/* Logo */}
            <div className="text-center mb-4">
              <img
                src={logo}
                width={400}
                alt="Logo"
                style={{ maxWidth: "100%", filter: "drop-shadow(0 2px 10px rgba(0,0,0,0.08))" }}
              />
            </div>

            {/* Card */}
            <div
              className="card border-0"
              style={{ borderRadius: "18px", boxShadow: "0 4px 30px rgba(0,0,0,0.09)", overflow: "hidden" }}
            >
              <div className="card-body p-4 p-md-5">
                <h5 style={{ fontWeight: 400, color: "#222", marginBottom: "1.75rem", fontSize: "1.3rem" }}>
                  Iniciá sesión
                </h5>

                <div className="mb-3">
                  <label style={labelStyle} htmlFor="usuario">Usuario</label>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    name="usuario"
                    placeholder="Ingresá tu usuario"
                    id="usuario"
                    onChange={actualizarUsuario}
                    style={inputStyle}
                  />
                </div>

                <div className="mb-3">
                  <label style={labelStyle} htmlFor="password">Contraseña</label>
                  <input
                    className="form-control form-control-lg"
                    type="password"
                    name="password"
                    placeholder="Ingresá tu contraseña"
                    id="password"
                    onChange={actualizarContrasenia}
                    style={inputStyle}
                  />
                </div>

                <div className="d-grid gap-2 mt-4">
                  <input
                    type="button"
                    value="Iniciar Sesión"
                    id="btnInicioSesion"
                    className="btn btn-lg"
                    onClick={iniciarSesion}
                    style={btnPrincipalStyle}
                  />
                   <button
    className="btn btn-lg"
    onClick={() => window.open("/dashboard.html", "_blank")}
    style={{
      ...btnPrincipalStyle,
      background: "transparent",
      color: "var(--color-principal, #008B9C)",
      border: "1.5px solid var(--color-principal, #008B9C)",
    }}
  >
    Dashboard de invitados
  </button>
  
                  <Button
                    variant="link"
                    onClick={handleShowModal}
                    style={{ color: "#888", fontSize: "0.875rem", textDecoration: "none" }}
                  >
                    ¿Olvidaste tu contraseña?
                  </Button>

                  
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header
          closeButton
          style={{ border: "none", paddingBottom: 0, paddingTop: "1.5rem", paddingLeft: "1.5rem" }}
        >
          <Modal.Title style={{ fontWeight: 500, fontSize: "1.2rem" }}>
            {modalPaso === 1 ? "Recuperar contraseña" : "Nueva contraseña"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "1rem 1.5rem 1.5rem" }}>
          {/* Indicador de pasos */}
          <div className="d-flex gap-2 mb-4">
            {[1, 2].map((n) => (
              <div
                key={n}
                style={{
                  height: "4px",
                  borderRadius: "2px",
                  flex: n === modalPaso ? 2 : 1,
                  background: n <= modalPaso ? "var(--color-principal, #008B9C)" : "#e0e0e0",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </div>

          {modalPaso === 1 && (
            <Form>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label style={labelStyle}>Correo Electrónico</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="tu@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>
              <button style={btnPrincipalStyle} onClick={SolicitarCodigo} type="button">
                Solicitar Código
              </button>
            </Form>
          )}

          {modalPaso === 2 && (
            <Form>
              <Form.Group className="mb-3" controlId="formCodigo">
                <Form.Label style={labelStyle}>Código de Verificación</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ingresá el código"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formNuevaContrasenia">
                <Form.Label style={labelStyle}>Nueva Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Nueva contraseña"
                  value={nuevaContrasenia}
                  onChange={(e) => setNuevaContrasenia(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formConfirmarContrasenia">
                <Form.Label style={labelStyle}>Confirmar Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirmá tu nueva contraseña"
                  value={confirmarContrasenia}
                  onChange={(e) => setConfirmarContrasenia(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>
              <button style={btnPrincipalStyle} onClick={CambiarContraseña} type="button">
                Cambiar Contraseña
              </button>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;